export const dynamicallyImportedInvoke = async <T>(cmd: string, args?: Record<string, unknown>, withCurrentWindow = false): Promise<T> => {
  if (withCurrentWindow) {
    const { getCurrentWebviewWindow } = await import('@tauri-apps/api/webviewWindow')
    if (!args) {
      args = {}
    }
    args.window = getCurrentWebviewWindow()
  }
  return import('@tauri-apps/api/core').then(async ({ invoke }) => {
    return invoke<T>(cmd, args)
  })
}
